export type IconProps = {
    width?: string;
    height?: string;
    ariaHidden?: boolean;
};
export function ArrowIcon(props: IconProps) {
    return (
        <>
            <svg
                aria-hidden={!!props.ariaHidden}
                width={props.width || '16'}
                height={props.height || '16'}
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M11 13.5L5.5 8L11 2.5' stroke='currentColor' strokeWidth='2.5' />
            </svg>
        </>
    );
}
